import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppSettingsResponse, RemoteDebuggerMode } from '@qodly/shared';
import { getCashedPrefrences } from '~store/utils';
import { ETooltipBehavior, EUnsavedPopOverChoice } from '../root/types';
import { fetchAppSettings, fetchSettings } from './thunks';
import { TSetSettingPayload, TSettingPath } from './types';
export interface ISettingsState {
  session: {
    [key: string]: unknown;
  };
  project: {
    [key: string]: unknown;
  };
  server: IAppSettingsResponse;
  welcometour: {
    [key: string]: unknown;
  };
}

const prefs = getCashedPrefrences();

const DEFAULT_PREFS = {
  session: {
    'studio.tips': true,
    'studio.notifications': true,
    'studio.enablePreview': false,
    'studio.tipsBaseUrl':
      'https://raw.githubusercontent.com/4d/Web-studio-TIPS/gh-build',
    'webforms.tooltip.behavior': ETooltipBehavior.SHOW_AFTER_TIMEOUT,
    'webforms.tooltip.timeout': 3000,
    'webforms.renderer.showPopOver': true,
    'webforms.renderer.showUnsavedPopOver': true,
    'webforms.renderer.unsavedPopOverChoice': EUnsavedPopOverChoice.NONE,
    'welcometour.active': true,
    'webforms.properties.advanced-mode': false,
    'monaco.zoom': 0,
    'model.viewport': {
      zoom: 1,
      y: 0,
      x: 0,
    },
  },
  project: {
    'webforms.renderer.indexPage': '',
    'webforms.display-mode': 'neutral',
  },
  server: {
    projectOpened: false,
    remoteDebuggerMode: RemoteDebuggerMode.DISABLED,
    baseUrl: '',
    qodly: true,
    urls: {
      renderer: '/$lib/renderer/',
      debugger: '',
      lsp: '',
    },
    isRestActive: true,
  },
};

const initialState: ISettingsState = {
  ...DEFAULT_PREFS,
  session: {
    ...DEFAULT_PREFS.session,
    ...prefs,
  },
  welcometour: {},
};

const stateSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSetting(state: ISettingsState, action: TSetSettingPayload) {
      const { path, settingsKey, value } = action.payload;

      state[path][settingsKey] = value;
    },
    setSettings(
      state: ISettingsState,
      action: PayloadAction<{
        path: TSettingPath;
        value: any;
      }>,
    ) {
      const { path, value } = action.payload;

      state[path] = {
        ...state[path],
        ...value,
      };
    },
    setSettingsAsText(
      state: ISettingsState,
      action: PayloadAction<{
        path: TSettingPath;
        settings: { [key: string]: unknown };
      }>,
    ) {
      const { path, settings } = action.payload;

      state[path] = settings;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchSettings.fulfilled, (state, action) => {
      state.project = {
        ...state.project,
        ...action.payload.content,
      };
    });

    builder.addCase(fetchAppSettings.fulfilled, (state, action) => {
      state.server = action.payload;
      if (state.server.qodly) {
        state.project['webforms.display-mode'] = 'airy';
      }
    });
  },
});

// uncomment to export actions from the slice.
export const { setSetting, setSettings, setSettingsAsText } =
  stateSlice.actions;

export default stateSlice;
